import webPlayerStorage from "./webPlayerStorage";

/**
 * Check if the current user has premium status
 * @returns {boolean} - True if user has premium
 */
export function isPremiumUser() {
  const webPlayerToken = webPlayerStorage.getToken();

  if (!webPlayerToken) {
    return false;
  }

  try {
    const tokenParts = webPlayerToken.split(".");

    if (tokenParts.length === 3) {
      const payload = JSON.parse(atob(tokenParts[1]));

      return payload.hasPremium === true;
    }
  } catch (error) {
    console.error("Error checking premium status:", error);
  }

  return false;
}

/**
 * Get user info from token
 * @returns {Object|null} - User info or null
 */
export function getUserFromToken() {
  const webPlayerToken = webPlayerStorage.getToken();

  if (!webPlayerToken) {
    return null;
  }

  try {
    const tokenParts = webPlayerToken.split(".");

    if (tokenParts.length === 3) {
      return JSON.parse(atob(tokenParts[1]));
    }
  } catch (error) {
    console.error("Error decoding token:", error);
  }

  return null;
}

const premiumUtils = {
  isPremiumUser,
  getUserFromToken,
};

export default premiumUtils;
